import { GenericValue } from 'hisng';

import { Person } from 'app/cs/psv/common/model/person/person';

// PSV Personendaten
export class PsvPersonProfile extends Person {
    // attributes #################################
    allfirstnames: string;
    nameprefix: string;
    namesuffix: string;
    artistname: string;
    personCompleteName: string;

    // to many relations #########################
    affiliations: PersonOrgunitRelation[];
    addresses: Address[];

    // for intern only ##########################
    lockVersion: number;

    // data received from extension points#######
    extendedData: any;

    personAttributes: any;

    constructor( id?: number, surname?: string, firstname?: string, gender?: GenericValue ) {
        super( id, surname, firstname, gender );
    }
}

// Funktionen der Person
class PersonOrgunitRelation {
    // attributes #################################
    id: number;
    organization: GenericValue;
    supplement: string;
    affiliationType: GenericValue;
    eaddresses: EAddress[];
    location: PostAddress;
    lockversion: number;
}

abstract class Address {
    // attributes #################################
    id: number;
    type: GenericValue;
    lockversion: number;
}

export class PostAddress extends Address {
    // attributes #################################
    street: string;
    postcode: string;
    city: string;
    addressaddition: string;
    postofficebox: string;
    company: string;
    divisionName: string;
    state: string;
    district: string;
    country: string;
    room: string;
    floor: string;
    building: string;
}

export class RoomAddress extends PostAddress {
    // attributes #################################
    building: string;
    floor: string;
    room: string;
}

export class EAddress extends Address {
    // attributes #################################
    eaddress: string;
}
